import InfoSection2 from './InfoSection2';

export default InfoSection2;